import React, { useState } from 'react'
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    CircularProgress,
} from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { NotificationManager } from 'react-notifications'
import getPaymentModeService from '../../../services/getPaymentModeService'

const AddEdit = ({ open, setOpen, dialogType, editValue, setEditValue, fetchData }) => {
    const [loading, setLoading] = useState(false);

    const validationSchema = Yup.object().shape({
        paymentModeName: Yup.string().required('Payment mode name is required'),
    })

    const formik = useFormik({
        initialValues: {
            paymentModeName: editValue?.paymentModeName || '',
        },
        validationSchema,
        enableReinitialize: true,
        onSubmit: async (values) => {
            setLoading(true);
            try {
                let response;
                if (dialogType === 'add') {
                    response = await getPaymentModeService.AddPaymentMode({
                        paymentModeName: values.paymentModeName
                    });
                } else {
                    response = await getPaymentModeService.UpdatePaymentMode({
                        paymentModeName: values.paymentModeName,
                        paymentModeId: editValue.paymentModeId,
                    });
                }

                console.log("response-p------" , response)

                if (response?.success) {
                
                    handleClose();
                    fetchData();
                } 
            } catch (error) {
                console.error('Error:', error);
                NotificationManager.error(
                    `Error ${dialogType === 'add' ? 'adding' : 'updating'} payment mode`,
                    'Error'
                );
            } finally {
                setLoading(false);
            }
        },
    })

    const handleClose = () => {
        setOpen(false);
        setEditValue(null);
        formik.resetForm();
    }

    return (
        <Dialog 
            open={open} 
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    minHeight: '300px',
                    '& .MuiDialogContent-root': {
                        padding: '20px 24px',
                    },
                    '& .MuiDialogActions-root': {
                        padding: '16px 24px',
                    }
                }
            }}
        >
            <DialogTitle sx={{ fontSize: '1.5rem', fontWeight: 600 }}>
                {dialogType === 'add' ? 'Add Payment Mode' : 'Edit Payment Mode'}
            </DialogTitle>
            <form onSubmit={formik.handleSubmit}>
                <DialogContent>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="paymentModeName"
                        label="Payment Mode Name"
                        value={formik.values.paymentModeName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.paymentModeName && Boolean(formik.errors.paymentModeName)}
                        helperText={formik.touched.paymentModeName && formik.errors.paymentModeName}
                        sx={{
                            '& .MuiInputBase-root': {
                                height: '48px',
                            },
                            '& .MuiInputLabel-root': {
                                fontSize: '1rem',
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={handleClose}
                        sx={{ 
                            fontSize: '1rem',
                            padding: '8px 16px'
                        }}
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="submit" 
                        variant="contained" 
                        color="primary"
                        disabled={loading}
                        sx={{ 
                            fontSize: '1rem',
                            padding: '8px 16px'
                        }}
                    >
                        {dialogType === 'add' ? 'Add' : 'Update'}
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}

export default AddEdit 